import React from "react";
import { Link } from "react-router-dom";
import useSWR from "swr";
import { FormattedMessage } from "react-intl";
import { Button } from "./components/button";
import { fetcherWithToken } from "./fetcher-with-token";
import {
  primaryButton,
  secondaryButton,
  inputVariants,
} from "./components/button.css";
import {
  containerMessageStyle,
  titleStyle,
  descriptionStyle,
  containerContactStyle,
  infoContactStyle,
  mainContentStyle,
} from "./tela-erro.css";
import { Space } from "./components/space";
import { ImagemErro } from "./illustration/ilustracao-erro";

export function Erro() {
  return (
    <>
      <Space />
      <div className={containerMessageStyle}>
        <div className={mainContentStyle}>
          <ImagemErro />
          <Space height={"2rem"} />
          <h1 className={titleStyle}>
            {" "}
            <FormattedMessage
              id="telaErro.titulo"
              defaultMessage="Parece que algo deu errado por aqui..."
            />
          </h1>
          <Space height={"2rem"} />
          <p className={descriptionStyle}>
            <FormattedMessage
              id="telaErro.descricao"
              defaultMessage="Sentimos muito por isso! Podemos tentar mais uma vez?"
            />
          </p>
          <Space height={"5rem"} />
          <Button
            className={`${primaryButton} ${inputVariants["transition-buttons"]}`}
            type={"button"}
            onClick={() => location.reload()}
          >
            <FormattedMessage
              id="telaErro.atualizarPagina"
              defaultMessage="Atualizar a página"
            />
          </Button>
        </div>
      </div>
    </>
  );
}
